import styled from '@emotion/styled';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var ErrorBoundaryBox = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  textAlign: 'center',
  margin: "var(--ds-space-600, 48px)".concat(" 0")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var ErrorHeading = styled.h3({
  marginTop: "var(--ds-space-400, 32px)",
  marginBottom: "var(--ds-space-100, 8px)",
  maxWidth: '240px'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var ErrorDescription = styled.p({
  maxWidth: '320px'
});